/* Search.

   1. Suggestions under the header field from 768 up: products and
      bundles as you type, from Shopify's predictive search drawn by
      sections/os-search-suggest.liquid. Recent searches when the field
      is empty. Arrow keys, Enter and Escape work.
   2. On a phone the search button opens a search screen of its own
      over the page, like an app: field and Cancel on top, Recent
      searches, results as you type, Back closes it.
   3. The results page (sections/os-search.liquid) updates in place as
      you type, sort or ask for more, without reloading.

   Recent searches live in this browser only, under localStorage
   "df_search_recent". Words come from the JSON block in
   snippets/os-header.liquid, in the visitor's language. */
(function () {
  "use strict";
  var D = document, W = window;
  if (W.__osSearch) return;
  W.__osSearch = 1;

  var COPY = {};
  try { COPY = JSON.parse((D.querySelector("[data-os-sr-copy]") || {}).textContent || "{}"); } catch (e) {}
  function c(k, en) { return (COPY && typeof COPY[k] === "string" && COPY[k]) || en; }
  var ROOT = COPY.root || "/";
  if (ROOT.slice(-1) !== "/") ROOT += "/";
  var SEARCH_URL = COPY.url || "/search";
  var REDUCED = W.matchMedia && W.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var ICON = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    go: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>'
  };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }
  function tokens(q) { return q.toLowerCase().split(/\s+/).filter(Boolean); }
  function searchHref(q) { return SEARCH_URL + "?q=" + encodeURIComponent(q) + "&type=product"; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* Recent searches */
  var KEY = "df_search_recent", MAX = 8;
  function recentGet() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === "string" && x; }) : [];
    } catch (e) { return []; }
  }
  function recentSet(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }
  function recentAdd(q) {
    q = (q || "").trim().replace(/\s+/g, " ");
    if (q.length < 2) return;
    var low = q.toLowerCase();
    var a = recentGet().filter(function (x) { return x.toLowerCase() !== low; });
    a.unshift(q);
    recentSet(a);
  }
  function recentRemove(q) { recentSet(recentGet().filter(function (x) { return x !== q; })); }
  function recentClear() { try { localStorage.removeItem(KEY); } catch (e) {} }

  /* What each instrument is for, from the copy deck, where the product
     has no type of its own. Same source the Shop's cards use. */
  function jobs() {
    var C = W.OS_CONTENT || {};
    return (C.SHOP && C.SHOP.jobs) || {};
  }
  function fillJobs(root) {
    var J = jobs();
    each(root.querySelectorAll("[data-sr-job]"), function (el) {
      if (el.textContent.trim()) return;
      var row = el.closest("[data-handle]");
      var j = row && J[row.getAttribute("data-handle")];
      if (j) el.textContent = j;
    });
    each(root.querySelectorAll(".os-p[data-handle] .os-p__job"), function (el) {
      if (el.textContent.trim()) return;
      var j = J[el.closest(".os-p").getAttribute("data-handle")];
      if (j) { el.textContent = j; el.hidden = false; }
    });
  }

  /* The bright part of a name is what was typed. */
  function highlight(el, toks) {
    var t = el.getAttribute("data-plain");
    if (t == null) { t = el.textContent; el.setAttribute("data-plain", t); }
    var low = t.toLowerCase(), on = [];
    toks.forEach(function (k) {
      var i = 0;
      while (k && (i = low.indexOf(k, i)) > -1) { for (var j = i; j < i + k.length; j++) on[j] = 1; i += k.length; }
    });
    var out = "", open = false;
    for (var i = 0; i < t.length; i++) {
      if (on[i] && !open) { out += "<b>"; open = true; }
      if (!on[i] && open) { out += "</b>"; open = false; }
      out += esc(t[i]);
    }
    if (open) out += "</b>";
    el.innerHTML = out;
  }

  /* Predictive search */
  var cache = {};
  /* Shopify's predictive search answers 417 in some languages (ar, ja,
     ko, th, zh-CN, zh-TW). After the first refusal the same section is
     asked for through the ordinary search page, matching the last word
     as a prefix. Those languages go there from the start. */
  var noPredictive = /^(ar|ja|ko|th|zh)/i.test(D.documentElement.lang || "");
  function suggestUrl(q) {
    if (noPredictive) {
      return ROOT + "search?q=" + encodeURIComponent(q) +
        "&type=product&options[prefix]=last&section_id=os-search-suggest";
    }
    return ROOT + "search/suggest?q=" + encodeURIComponent(q) +
      "&resources[type]=product,query&resources[limit]=10&resources[limit_scope]=each" +
      "&resources[options][unavailable_products]=last&section_id=os-search-suggest";
  }
  function fetchSuggest(q, signal) {
    var key = q.toLowerCase();
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(suggestUrl(q), { signal: signal, credentials: "same-origin" })
      .then(function (r) {
        if (r.status === 417 && !noPredictive) { noPredictive = true; return fetch(suggestUrl(q), { signal: signal, credentials: "same-origin" }); }
        return r;
      })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, "text/html");
        var out = doc.querySelector("[data-sr-out]");
        var res = {
          html: out ? out.innerHTML : "",
          count: out ? parseInt(out.getAttribute("data-count") || "0", 10) : 0,
          qs: out ? out.querySelectorAll("[data-sr-q]").length : 0
        };
        cache[key] = res;
        return res;
      });
  }

  /* One list of suggestions, drawn into `body`. Used by the header
     panel and by the phone search screen. */
  function makeList(o) {
    var input = o.input, body = o.body, wrap = o.wrap;
    var timer = 0, ctl = null, sizeTimer = 0, shownFor = null;

    function setLoading(on) {
      if (on) { wrap.classList.remove("is-loaded"); wrap.classList.add("is-loading"); }
      else if (wrap.classList.contains("is-loading")) {
        wrap.classList.remove("is-loading"); wrap.classList.add("is-loaded");
      }
    }

    function sized(fn) {
      if (!o.animateHeight || REDUCED || !o.isOpen()) { fn(); return; }
      var h0 = body.offsetHeight;
      body.classList.remove("is-sizing");
      body.style.height = "";
      fn();
      var h1 = body.scrollHeight;
      if (Math.abs(h1 - h0) < 2) return;
      body.style.height = h0 + "px";
      void body.offsetHeight;
      body.classList.add("is-sizing");
      body.style.height = h1 + "px";
      clearTimeout(sizeTimer);
      sizeTimer = setTimeout(function () { body.classList.remove("is-sizing"); body.style.height = ""; }, 200);
    }

    function allRow(q) {
      return '<a class="os-sr__all" href="' + esc(searchHref(q)) + '" data-sr-item data-sr-all>' + ICON.search +
        "<span>" + esc(c("see_all", "See all results")) + "</span><b>" + esc(q) + "</b><i>" + ICON.go + "</i></a>";
    }

    function paintRecent() {
      shownFor = "";
      var a = recentGet();
      sized(function () {
        if (!a.length) {
          body.innerHTML = o.hintWhenEmpty ? '<p class="os-sr__none">' + esc(c("hint", "")) + "</p>" : "";
          return;
        }
        body.innerHTML =
          '<div class="os-sr__rhead"><p class="os-sr__cap">' + esc(c("recent", "Recent searches")) + "</p>" +
          '<button type="button" class="os-sr__clear" data-sr-clear>' + esc(c("clear", "Clear")) + "</button></div>" +
          a.map(function (q, i) {
            return '<div class="os-sr__recent is-new" style="--i:' + i + '" role="option" data-sr-item data-sr-recent="' + esc(q) + '">' +
              ICON.clock + "<span>" + esc(q) + "</span>" +
              '<button type="button" class="os-sr__x" data-sr-remove aria-label="' + esc(c("remove", "Remove") + " " + q) + '">' + ICON.x + "</button></div>";
          }).join("");
      });
      o.onContent(!!a.length || !!o.hintWhenEmpty);
    }

    function paint(res, q) {
      var prev = {};
      each(body.querySelectorAll("[data-handle]"), function (el) { prev[el.getAttribute("data-handle")] = 1; });
      var toks = tokens(q);
      sized(function () {
        var html = res.html;
        if (!res.count) html = '<p class="os-sr__none">' + esc(c("none", "Nothing matches “%Q%”.").replace("%Q%", q)) + "</p>" + html;
        body.innerHTML = html + (res.count ? allRow(q) : "");
        var n = 0;
        each(body.querySelectorAll("[data-sr-item]"), function (el) {
          var h = el.getAttribute("data-handle");
          if (h && prev[h]) return;
          if (h || shownFor !== q.toLowerCase()) { el.classList.add("is-new"); el.style.setProperty("--i", Math.min(n++, 10)); }
        });
        each(body.querySelectorAll(".os-sr__name"), function (el) { highlight(el, toks); });
        fillJobs(body);
      });
      shownFor = q.toLowerCase();
      o.onContent(true);
    }

    /* While Shopify answers, the rows already showing are narrowed to
       what still matches, so every key press changes something at once. */
    function narrow(q) {
      var toks = tokens(q);
      each(body.querySelectorAll(".os-sr__row[data-name]"), function (el) {
        var name = el.getAttribute("data-name");
        el.hidden = !toks.every(function (k) { return name.indexOf(k) > -1; });
        var nm = el.querySelector(".os-sr__name");
        if (nm) highlight(nm, toks);
      });
      var all = body.querySelector("[data-sr-all] b");
      if (all) all.textContent = q;
    }

    function update() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (ctl) { ctl.abort(); ctl = null; }
      if (!q) { setLoading(false); paintRecent(); return; }
      var hit = cache[q.toLowerCase()];
      if (hit) { setLoading(false); paint(hit, q); return; }
      narrow(q);
      timer = setTimeout(function () {
        ctl = W.AbortController ? new AbortController() : null;
        setLoading(true);
        fetchSuggest(q, ctl && ctl.signal).then(function (res) {
          if (input.value.trim() !== q) return;
          setLoading(false);
          paint(res, q);
        }).catch(function () { setLoading(false); });
      }, 60);
    }

    function items() {
      return Array.prototype.filter.call(body.querySelectorAll("[data-sr-item]"), function (el) { return !el.hidden; });
    }
    function active() { return body.querySelector("[data-sr-item].is-on"); }
    function move(d) {
      var list = items();
      if (!list.length) return;
      var cur = active(), i = list.indexOf(cur);
      if (cur) cur.classList.remove("is-on");
      i = i + d;
      if (i < -1) i = list.length - 1;
      if (i >= list.length) i = -1;
      if (i === -1) { input.removeAttribute("aria-activedescendant"); return; }
      var el = list[i];
      el.classList.add("is-on");
      if (!el.id) el.id = "os-sr-i" + Math.random().toString(36).slice(2, 8);
      input.setAttribute("aria-activedescendant", el.id);
      el.scrollIntoView({ block: "nearest" });
    }

    function navigate(href) { o.navigate ? o.navigate(href) : (location.href = href); }

    function activate(el) {
      if (!el) return false;
      var q = input.value.trim();
      if (el.hasAttribute("data-sr-q")) {
        input.value = el.getAttribute("data-sr-q");
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.focus();
        return true;
      }
      if (el.hasAttribute("data-sr-recent")) {
        var r = el.getAttribute("data-sr-recent");
        input.value = r;
        recentAdd(r);
        navigate(searchHref(r));
        return true;
      }
      if (el.href) { recentAdd(q); navigate(el.href); return true; }
      return false;
    }

    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); move(1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); move(-1); }
      else if (e.key === "Enter" && !e.isComposing) {
        var a = active();
        if (a) { e.preventDefault(); activate(a); }
      }
    });

    body.addEventListener("click", function (e) {
      var t = e.target;
      var rm = t.closest("[data-sr-remove]");
      if (rm) {
        e.preventDefault(); e.stopPropagation();
        var row = rm.closest("[data-sr-recent]");
        var q = row.getAttribute("data-sr-recent");
        row.classList.remove("is-new");
        row.classList.add("is-going");
        setTimeout(function () { recentRemove(q); if (!input.value.trim()) paintRecent(); }, REDUCED ? 0 : 160);
        return;
      }
      if (t.closest("[data-sr-clear]")) {
        e.preventDefault(); recentClear(); paintRecent(); input.focus(); return;
      }
      var it = t.closest("[data-sr-item]");
      if (!it) return;
      if (it.hasAttribute("data-sr-q") || it.hasAttribute("data-sr-recent") || o.navigate) {
        e.preventDefault();
        activate(it);
        return;
      }
      if (it.href) recentAdd(input.value.trim());
    });

    body.addEventListener("mousemove", function (e) {
      var it = e.target.closest && e.target.closest("[data-sr-item]");
      var cur = active();
      if (cur && cur !== it) cur.classList.remove("is-on");
    });

    return { update: update, paintRecent: paintRecent };
  }

  /* 1. The header panel, 768 and up */
  var header = D.querySelector(".os-header");
  var hform = D.querySelector("[data-os-sr-form]");
  var hinput = hform && hform.querySelector('input[name="q"]');
  var pop = null, popList = null, popOpen = false, popWant = false;

  function isPhone() { return W.innerWidth < 768; }

  if (header && hform && hinput) {
    pop = D.createElement("div");
    pop.className = "os-sr os-sr--pop";
    pop.id = "os-sr-pop";
    pop.setAttribute("role", "listbox");
    pop.setAttribute("aria-label", c("suggest", "Suggestions"));
    pop.innerHTML = '<div class="os-sr__load"></div><div class="os-sr__scroll"><div class="os-sr__body"></div></div>';
    header.appendChild(pop);
    hinput.setAttribute("aria-controls", pop.id);

    var place = function () {
      var hr = header.getBoundingClientRect(), fr = hform.getBoundingClientRect();
      var w = Math.min(Math.max(fr.width, 520), hr.width - 24);
      var left = fr.left - hr.left;
      if (left + w > hr.width - 12) left = Math.max(12, hr.width - 12 - w);
      pop.style.setProperty("--sr-left", Math.round(left) + "px");
      pop.style.setProperty("--sr-w", Math.round(w) + "px");
      pop.style.setProperty("--sr-top", Math.round(fr.bottom - hr.top + 8) + "px");
    };
    var showPop = function (on) {
      on = on && !isPhone() && D.activeElement === hinput;
      if (on === popOpen) return;
      popOpen = on;
      if (on) place();
      pop.classList.toggle("is-open", on);
      hform.classList.toggle("is-suggesting", on);
      hinput.setAttribute("aria-expanded", on ? "true" : "false");
    };

    popList = makeList({
      input: hinput,
      body: pop.querySelector(".os-sr__body"),
      wrap: pop,
      animateHeight: true,
      isOpen: function () { return popOpen; },
      onContent: function (has) { popWant = has; showPop(has); }
    });

    /* Keeps the field focused when the pointer goes down in the panel,
       so the panel does not close under the click. */
    pop.addEventListener("mousedown", function (e) { e.preventDefault(); });

    hinput.addEventListener("focus", function () { if (!isPhone()) popList.update(); });
    hinput.addEventListener("input", function () { if (!isPhone()) popList.update(); });
    hinput.addEventListener("blur", function () { setTimeout(function () { if (D.activeElement !== hinput) showPop(false); }, 0); });
    hinput.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (popOpen) { e.stopPropagation(); showPop(false); } else hinput.blur();
      }
    });
    hform.addEventListener("submit", function () { recentAdd(hinput.value); });
    W.addEventListener("resize", function () { if (popOpen) { if (isPhone()) showPop(false); else place(); } });

    /* Warm the connection on first hover so the first letter typed is
       answered quickly. */
    hform.addEventListener("pointerenter", function warm() {
      hform.removeEventListener("pointerenter", warm);
      fetchSuggest("omni").catch(function () {});
    });
  }

  /* 2. The phone search screen */
  var sheet = null, sinput = null, sheetOpen = false, sheetList = null;

  function buildSheet() {
    sheet = D.createElement("div");
    sheet.className = "os-sr os-sr--sheet";
    sheet.setAttribute("role", "dialog");
    sheet.setAttribute("aria-modal", "true");
    sheet.setAttribute("aria-label", c("search", "Search"));
    sheet.innerHTML =
      '<div class="os-sr__bar">' +
        '<form class="os-sr__field" action="' + esc(SEARCH_URL) + '" method="get" role="search" autocomplete="off">' +
          ICON.search +
          '<input type="hidden" name="type" value="product">' +
          '<input type="search" name="q" placeholder="' + esc(c("search", "Search")) + '" aria-label="' + esc(c("search", "Search")) +
          '" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" role="combobox" aria-autocomplete="list" aria-controls="os-sr-sheet-list" aria-expanded="true">' +
          '<button type="button" class="os-sr__x" data-sr-wipe aria-label="' + esc(c("clear_field", "Clear search")) + '" hidden>' + ICON.x + "</button>" +
        "</form>" +
        '<button type="button" class="os-sr__cancel" data-sr-cancel>' + esc(c("cancel", "Cancel")) + "</button>" +
        '<div class="os-sr__load"></div>' +
      "</div>" +
      '<div class="os-sr__scroll"><div class="os-sr__body" id="os-sr-sheet-list" role="listbox"></div></div>';
    D.body.appendChild(sheet);
    sinput = sheet.querySelector('input[name="q"]');
    var sform = sheet.querySelector("form");
    var wipe = sheet.querySelector("[data-sr-wipe]");
    var scroller = sheet.querySelector(".os-sr__scroll");
    var bar = sheet.querySelector(".os-sr__bar");

    sheetList = makeList({
      input: sinput,
      body: sheet.querySelector(".os-sr__body"),
      wrap: bar,
      animateHeight: false,
      hintWhenEmpty: true,
      isOpen: function () { return sheetOpen; },
      onContent: function () {},
      /* Leaving from the search screen replaces its history entry, so
         Back from the next page returns to the page underneath. */
      navigate: function (href) { location.replace(href); }
    });

    sinput.addEventListener("input", function () { wipe.hidden = !sinput.value; sheetList.update(); });
    wipe.addEventListener("mousedown", function (e) { e.preventDefault(); });
    wipe.addEventListener("click", function () { sinput.value = ""; wipe.hidden = true; sheetList.update(); sinput.focus(); });
    sform.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = sinput.value.trim();
      if (!q) return;
      recentAdd(q);
      location.replace(searchHref(q));
    });
    sheet.querySelector("[data-sr-cancel]").addEventListener("click", function () { closeSheet(false); });
    sheet.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSheet(false); });
    scroller.addEventListener("scroll", function () { sheet.classList.toggle("is-scrolled", scroller.scrollTop > 2); }, { passive: true });
    /* Moving the list puts the keyboard away, as an app does. */
    scroller.addEventListener("touchmove", function () { if (D.activeElement === sinput) sinput.blur(); }, { passive: true });
  }

  function openSheet() {
    if (!sheet) buildSheet();
    if (sheetOpen) { sinput.focus(); return; }
    sheetOpen = true;
    var start = (hinput && hinput.value) || "";
    sinput.value = start;
    sheet.querySelector("[data-sr-wipe]").hidden = !start;
    sheet.classList.add("is-open");
    /* Focused inside the tap, or iOS will not raise the keyboard. */
    try { sinput.focus({ preventScroll: true }); } catch (e) { sinput.focus(); }
    D.body.classList.add("os-locked");
    D.documentElement.classList.add("os-sr-on");
    try { history.pushState({ osSr: 1 }, ""); } catch (e) {}
    sheetList.update();
  }

  function closeSheet(fromHistory) {
    if (!sheetOpen) return;
    sheetOpen = false;
    sheet.classList.remove("is-open", "is-scrolled");
    sinput.blur();
    D.body.classList.remove("os-locked");
    D.documentElement.classList.remove("os-sr-on");
    if (!fromHistory && history.state && history.state.osSr) { try { history.back(); } catch (e) {} }
  }

  W.addEventListener("popstate", function () { if (sheetOpen) closeSheet(true); });

  /* The header's search button opens the search screen on a phone.
     Caught on the way down, before os.js's own handler would widen
     the header field instead. */
  D.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-os-searchbtn]");
    if (!b || !isPhone()) return;
    e.preventDefault();
    e.stopPropagation();
    openSheet();
  }, true);

  /* 3. The results page */
  var sp = D.querySelector("[data-os-sp]");
  if (sp) {
    var pinput = sp.querySelector("[data-sp-q]");
    var pform = sp.querySelector("[data-sp-form]");
    var pwipe = sp.querySelector("[data-sp-wipe]");
    var field = sp.querySelector(".os-sp__field");
    var outEl = sp.querySelector("[data-sp-out]");
    var sectionId = sp.getAttribute("data-section");
    var ptimer = 0, pctl = null, current = pinput ? pinput.value.trim() : "";

    var paramsFor = function (q, extra) {
      var p = new URLSearchParams(location.search);
      p.delete("page"); p.delete("section_id");
      if (q) p.set("q", q); else p.delete("q");
      if (!p.get("type")) p.set("type", "product");
      p.set("options[prefix]", "last");
      Object.keys(extra || {}).forEach(function (k) { if (extra[k]) p.set(k, extra[k]); else p.delete(k); });
      return p;
    };

    var paintRecentChips = function () {
      var box = outEl.querySelector("[data-sp-recent]");
      if (!box) return;
      var a = recentGet();
      box.hidden = !a.length;
      if (!a.length) { box.innerHTML = ""; return; }
      box.innerHTML =
        '<div class="os-sr__rhead"><p class="os-sr__cap">' + esc(c("recent", "Recent searches")) + "</p>" +
        '<button type="button" class="os-sr__clear" data-sr-clear>' + esc(c("clear", "Clear")) + "</button></div>" +
        '<div class="os-sp__chips">' + a.map(function (q) {
          return '<a class="os-sp__chip" href="' + esc(searchHref(q)) + '" data-sp-recent="' + esc(q) + '">' + esc(q) +
            '<button type="button" class="os-sr__x" data-sr-remove aria-label="' + esc(c("remove", "Remove") + " " + q) + '">' + ICON.x + "</button></a>";
        }).join("") + "</div>";
    };

    var mark = function (nodes, prev) {
      var n = 0;
      each(nodes, function (el) {
        var h = el.getAttribute("data-handle");
        if (h && prev[h]) return;
        el.classList.add("is-new");
        el.style.setProperty("--i", Math.min(n++, 12));
      });
    };

    var settle = function () { fillJobs(outEl); paintRecentChips(); };

    var live = function (q, extra, force) {
      if (!force && q === current && !extra) return;
      current = q;
      clearTimeout(ptimer);
      if (pctl) pctl.abort();
      pctl = W.AbortController ? new AbortController() : null;
      var params = paramsFor(q, extra);
      var url = location.pathname + "?" + params.toString();
      outEl.classList.add("is-busy");
      field.classList.remove("is-loaded"); field.classList.add("is-loading");
      var prev = {};
      each(outEl.querySelectorAll(".os-p[data-handle]"), function (el) { prev[el.getAttribute("data-handle")] = 1; });
      fetch(url + "&section_id=" + encodeURIComponent(sectionId), { signal: pctl && pctl.signal, credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, "text/html");
          var next = doc.querySelector("[data-sp-out]");
          if (!next) throw new Error("no out");
          outEl.innerHTML = next.innerHTML;
          mark(outEl.querySelectorAll(".os-pgrid > .os-p"), prev);
          settle();
          try { history.replaceState(history.state, "", url); } catch (e) {}
          var tail = D.title.split(" – ").pop();
          D.title = q ? q + " – " + tail : tail;
          if (hinput) hinput.value = q;
        })
        .catch(function (err) { if (err && err.name === "AbortError") return; location.href = url; })
        .then(function () {
          outEl.classList.remove("is-busy");
          field.classList.remove("is-loading"); field.classList.add("is-loaded");
        });
    };

    if (pinput) {
      pinput.addEventListener("input", function () {
        if (pwipe) pwipe.hidden = !pinput.value;
        clearTimeout(ptimer);
        var q = pinput.value.trim();
        ptimer = setTimeout(function () { live(q); }, q ? 220 : 120);
      });
      pform.addEventListener("submit", function (e) {
        e.preventDefault();
        var q = pinput.value.trim();
        recentAdd(q);
        live(q, null, true);
        if (W.matchMedia("(hover: none)").matches) pinput.blur();
      });
      if (pwipe) {
        pwipe.addEventListener("mousedown", function (e) { e.preventDefault(); });
        pwipe.addEventListener("click", function () { pinput.value = ""; pwipe.hidden = true; live(""); pinput.focus(); });
      }
    }

    outEl.addEventListener("change", function (e) {
      if (e.target.matches("[data-sp-sort]")) live(current, { sort_by: e.target.value }, true);
    });

    outEl.addEventListener("click", function (e) {
      var t = e.target;
      var rm = t.closest("[data-sr-remove]");
      if (rm) {
        e.preventDefault(); e.stopPropagation();
        recentRemove(rm.closest("[data-sp-recent]").getAttribute("data-sp-recent"));
        paintRecentChips();
        return;
      }
      if (t.closest("[data-sr-clear]")) { e.preventDefault(); recentClear(); paintRecentChips(); return; }
      var chip = t.closest("[data-sp-recent]");
      if (chip) {
        e.preventDefault();
        var q = chip.getAttribute("data-sp-recent");
        pinput.value = q;
        if (pwipe) pwipe.hidden = false;
        recentAdd(q);
        live(q, null, true);
        return;
      }
      var more = t.closest("[data-sp-more]");
      if (more) {
        e.preventDefault();
        if (more.classList.contains("is-loading")) return;
        more.classList.add("is-loading");
        var prev = {};
        each(outEl.querySelectorAll(".os-p[data-handle]"), function (el) { prev[el.getAttribute("data-handle")] = 1; });
        var href = more.getAttribute("href");
        fetch(href + (href.indexOf("?") > -1 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId), { credentials: "same-origin" })
          .then(function (r) { return r.text(); })
          .then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, "text/html");
            var grid = outEl.querySelector("[data-sp-grid]"), ngrid = doc.querySelector("[data-sp-grid]");
            if (grid && ngrid) {
              var added = [];
              each(ngrid.children, function (el) { added.push(el); });
              added.forEach(function (el) { grid.appendChild(el); });
              mark(added, prev);
            }
            var list = outEl.querySelector("[data-sp-list]"), nlist = doc.querySelector("[data-sp-list]");
            if (nlist) {
              if (list) each(Array.prototype.slice.call(nlist.children), function (el) { list.appendChild(el); });
              else {
                var nh = doc.querySelector("[data-sp-listwrap]");
                var pages = outEl.querySelector("[data-sp-pages]");
                if (nh && pages) pages.parentNode.insertBefore(nh, pages);
              }
            }
            var pages = outEl.querySelector("[data-sp-pages]"), npages = doc.querySelector("[data-sp-pages]");
            if (pages) { if (npages) pages.innerHTML = npages.innerHTML; else pages.remove(); }
            settle();
          })
          .catch(function () { location.href = href; });
        return;
      }
      if (t.closest(".os-p, .os-sp__item")) recentAdd(current);
    });

    settle();
  }

  /* Rows already on the page when this runs. */
  fillJobs(D);
})();
